import { createRouter, createWebHistory } from "vue-router";

import admin from "./admin";
import booking from "./booking";
import click_and_collect from "./click_and_collect";
import ordering_table from "./ordering_table";
import gift_vouchers from "./gift_vouchers";
import campaigns from "./campaigns";
import websites from "./websites";
import common from "./common";

import Page404 from "../pages/404.vue";
import store from "../store/store";
import i18n from "../plugins/i18n";

const router = createRouter({
    history: createWebHistory(),
    routes: [
        ...admin,
        ...booking,
        ...click_and_collect,
        ...ordering_table,
        ...gift_vouchers,
        ...campaigns,
        ...websites,
        ...common,
        {
            path: "/:pathMatch(.*)*",
            name: "notfound",
            component: Page404,
        },
    ],
});

router.beforeEach((to, from, next) => {
    const fromName = from ? from.name : null;
    const toName = to ? to.name : null;

    if (!fromName || !toName) {
        return next();
    }

    const fromNameExploded = fromName.split(".");
    const toNameExploded = toName.split(".");

    if (fromNameExploded[0] === "website" && store.getters["websites/unsaved_changes"]) {
        if (
            toNameExploded[0] === "website" &&
            toNameExploded.length > 2 &&
            fromNameExploded.length > 2 &&
            toNameExploded[2] === fromNameExploded[2]
        ) {
            return next();
        }

        if (confirm(i18n.global.t("questions.common.unsavedChanges"))) {
            store.dispatch("websites/setUnsavedChanges", false);
            next();
        }

        return;
    }

    if (
        fromName === "booking.restaurants.settings.notifications" &&
        toName !== "booking.restaurants.settings.notifications" &&
        store.getters["restaurants/unsavedNotificationsChanges"]
    ) {
        if (confirm(i18n.global.t("questions.common.unsavedChanges"))) {
            store.dispatch("restaurants/setUnsavedNotificationsChanges", false);
            next();
        }

        return;
    }

    return next();
});

router.beforeResolve((to, from, next) => {
    const to_restaurant_id = Object.keys(to.params).length > 0 && to.params.restaurant_id ? to.params.restaurant_id : 0;

    if (to_restaurant_id && (to.name || "").startsWith("booking")) {
        store.dispatch("widgets/getCurrentWidget", { restaurant_id: to_restaurant_id });
    }

    return next();
});

export default router;
